import CustomLayout from "components/Layout";
import TabsComp from "components/TabsComp";
import React, { useState } from "react";
// import Events from "./Events";
import Charts from "./Charts";
import CDR from "./CDR";
// import useSosStatuses from "hooks/useSosStatuses";

const MainSOS: React.FC = () => {
    
    const [activeKey, setActiveKey] = useState<string>("tab-1");

    // const hookSosStatuses = useSosStatuses({ orderBy: "desc", pageSize: 20, page: 1 });

    return (
        <CustomLayout>
            <TabsComp
                defaultActiveKey={activeKey}
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                items={[{
                    key: "tab-1",
                    label: "Registro Detallado de Llamadas",
                    children: <CDR />
                }, {
                //     key: "tab-2",
                //     label: "Eventos",
                //     children: <Events hookSosStatuses={hookSosStatuses} />
                // }, {
                    key: "tab-3",
                    label: "Gráficos",
                    children: <Charts />
                }]}

            />
        </CustomLayout>
    );
}

export default MainSOS;